import {ChangeDetectionStrategy, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {MatTab, MatTabGroup, MatTabLabel} from "@angular/material/tabs";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
    selector: 'app-day-quality',
    templateUrl: './day-quality.component.html',
    imports: [
        MatTabGroup,
        MatTab,
        TranslatePipe,
        MatTabLabel
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./day-quality.component.scss']
})
export class DayQualityComponent implements OnInit {

    dayQualityTabIndex = 0;

    dayQualityEntries: string [] = ["warm", "cold", "light", "water"]

    constructor(
        @Inject(MAT_DIALOG_DATA) public dayQualityId: string
    ) {
    }

    ngOnInit(): void {
        this.initActiveTab();
    }

    private initActiveTab() {
        const tabIndex = this.dayQualityEntries.indexOf(this.dayQualityId, 0)
        this.dayQualityTabIndex = tabIndex
    }

}
